// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { basketSetKeyboard, basketClear } from '../../actions/basket';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';

import MobileBasketModal from './BasketMobileModal';
import selectBasketMobileModalProps from './BasketMobileModal.selector';

type BasketMobileModalContainerProps = {
  isOpen: boolean;
  closeModal: () => void;
};

const BasketMobileModalContainer = (ownProps: BasketMobileModalContainerProps) => {
  const selectedProps = useSelector(selectBasketMobileModalProps);

  const actions = useMemo(() => ({ basketSetKeyboard, basketClear }), []);
  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });

  return <MobileBasketModal {...enhancedProps} />;
};

export default BasketMobileModalContainer;
